import { Card, Grid, Paper, Typography, CardContent, Stack, TextField } from '@mui/material';
import React, { useCallback } from 'react';
import { Link as RouterLink } from 'react-router-dom';
import { useNavigate, useParams } from 'react-router-dom';
import Loading from '../components/Loading';
import { Box } from '@mui/system';
import { useGetDesignCategoryDesignsQuery, useGetDesignCategoryQuery, useUpdateDesignCategoryMutation } from '../features/model/designcategorySlice';
import { useCreateDesignMutation } from '../features/model/designSlice';
import DropArea from '../components/DropArea';
import { svg_to_img } from '../helpers/images';

const DesignAddNewCard = ({onAddDesign = null}) => {
  return (
      <Paper elevation={1}><Card key="add_new" sx={{width: 256, minHeight: 140, paddingTop: 2}}>
          <center><Typography variant="subtitle1">Upload SVG to<br />add a new design</Typography></center>
          <Box sx={{marginLeft: 4, marginRight: 4, marginTop: 1, marginBottom: 1}}><DropArea fileHandler={onAddDesign}/></Box>
      </Card></Paper>);
}

const DesignCard = ({design}) => {
  const makeLinkToDesign = (design) => {
    return `/designs/${design.category}/${design.id}`
  }

  return <Grid item component={RouterLink} to={makeLinkToDesign(design)}>
    <Paper elevation={1}>
      <Card sx={{width: 256, minHeight: 140, paddingTop: 4}}>
        <CardContent>
          <Stack direction="column">
            <center><img alt={design.name} src={svg_to_img(design.contents)} style={{width: "64px", height: "auto"}} /></center>
          <Typography variant="subtitle1" textAlign="center">{design.name}</Typography>
          </Stack>
        </CardContent>
      </Card>
    </Paper>
  </Grid>
}

const DesignsBrowser = () => {
    let params = useParams();

    const {data: object, error: objectError, isLoading: objectIsLoading} = useGetDesignCategoryQuery(params.categoryId)
    const {data: designs, error, isLoading } = useGetDesignCategoryDesignsQuery(params.categoryId)

    const [uploadDesign, {isLoadingDesign: isUploading }] = useCreateDesignMutation();
    const [updateObject] = useUpdateDesignCategoryMutation();
    const uploadImage = useCallback((files) => {
        let file = files[0];
        const reader = new FileReader()
        reader.onabort = () => console.log('file reading was aborted')
        reader.onerror = () => console.log('file reading has failed')
        reader.onload = () => {
          const textStr = reader.result
          uploadDesign({category: params.categoryId, contents: textStr, name: file.name.split(".")[0]})
        }
        reader.readAsText(file)
    });

    if (isLoading || objectIsLoading) {
      return <Loading />;
    }
    if (error || objectError) {
      return <div>Error: {error}</div>
    }

    const sortedDesigns = designs.objects.slice().sort((a, b) => a.name.localeCompare(b.name))

    return <Stack direction="column" sx={{margin: 2}}>
      <TextField label="Name of category" defaultValue={object.name} sx={{width: 400}} onChange={(event) => {
                updateObject({designcategory_id: object.id, data: {name: event.target.value}});
            }} />
      <Grid container spacing={2} sx={{marginTop: 2, marginBottom: 4}}>
        {
            sortedDesigns.map((design, i) => <DesignCard design={design} key={design.id} />)
        }
        <Grid item key="new"><DesignAddNewCard onAddDesign={uploadImage}/></Grid>
        </Grid></Stack>
}

export default DesignsBrowser;
